import React, { useState, useEffect } from 'react';
import Loader from '../../components/common/Loader';
import StatCard from '../../components/common/StatCard';
import { apiClient } from '../../api/client';
import { useToast } from '../../context/ToastContext';

const AdminOverview = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const { addToast } = useToast();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await apiClient.get('/stats');
        setStats(response.data);
      } catch (err) {
        addToast('Failed to load platform stats', 'error');
      } finally {
        setLoading(false);
      }
    };
    
    fetchStats();
  }, [addToast]);

  if (loading) return <div className="flex justify-center py-20"><Loader /></div>;

  return (
    <div>
      <div className="mb-8">
        <h1 className="admin-page-title">Platform Overview</h1>
        <p className="admin-page-sub">Current statistics and platform health.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard title="Total Students" value={stats?.total_students || 0} icon="🎓" className="!border-l-4 !border-l-primary" />
        <StatCard title="Total Companies" value={stats?.total_companies || 0} icon="🏢" className="!border-l-4 !border-l-accent" />
        <StatCard title="Total Jobs" value={stats?.total_jobs || 0} icon="💼" className="!border-l-4 !border-l-success" />
        <StatCard title="Total Applications" value={stats?.total_applications || 0} icon="📄" className="!border-l-4 !border-l-warning" />
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="card-elevated">
          <h3 className="heading-3 mb-4">Quick Actions</h3>
          <div className="grid grid-cols-2 gap-4">
            <button className="p-4 border border-gray-200 rounded-lg text-left hover:border-primary transition-colors hover:shadow-sm">
              <div className="text-xl mb-2">🏢</div>
              <div className="font-semi text-gray-900 text-sm">Review Companies</div>
              <div className="text-xs text-gray-500 mt-1">Pending approvals</div>
            </button>
            <button className="p-4 border border-gray-200 rounded-lg text-left hover:border-primary transition-colors hover:shadow-sm">
              <div className="text-xl mb-2">📢</div>
              <div className="font-semi text-gray-900 text-sm">Post Admin Job</div>
              <div className="text-xs text-gray-500 mt-1">Curated opportunities</div>
            </button>
            <button className="p-4 border border-gray-200 rounded-lg text-left hover:border-primary transition-colors hover:shadow-sm">
              <div className="text-xl mb-2">🎓</div>
              <div className="font-semi text-gray-900 text-sm">Manage Students</div>
              <div className="text-xs text-gray-500 mt-1">View user accounts</div>
            </button>
            <button className="p-4 border border-gray-200 rounded-lg text-left hover:border-primary transition-colors hover:shadow-sm">
              <div className="text-xl mb-2">⚙️</div>
              <div className="font-semi text-gray-900 text-sm">Platform Settings</div>
              <div className="text-xs text-gray-500 mt-1">Configure options</div>
            </button>
          </div>
        </div>
        
        <div className="card-elevated">
          <h3 className="heading-3 mb-4">System Status</h3>
          <div className="flex-col gap-4">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded border border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-success"></div>
                <span className="font-medium text-sm">API Backend</span>
              </div>
              <span className="text-xs text-gray-500">Operational</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded border border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-success"></div>
                <span className="font-medium text-sm">Database</span>
              </div>
              <span className="text-xs text-gray-500">Operational</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded border border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-success"></div>
                <span className="font-medium text-sm">Email Service</span>
              </div>
              <span className="text-xs text-gray-500">Operational</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminOverview;
